var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, forwardRef } from "react";
import { Children } from "react";
import classNames from "classnames";
var ButtonGroup = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, size = _a.size, inline = _a.inline, iconPosition = _a.iconPosition, reverse = _a.reverse, equisized = _a.equisized, align = _a.align, children = _a.children, titleName = _a.titleName, style = _a.style, otherProps = __rest(_a, ["className", "size", "inline", "iconPosition", "reverse", "equisized", "align", "children", "titleName", "style"]);
    var buttonGroupRef = useRef(null);
    useEffect(function () {
        var handleResize = function () {
            if (!buttonGroupRef.current) {
                return;
            }
            if (equisized) {
                buttonGroupRef.current.style.setProperty("--equisized-width", "auto");
                var buttons = buttonGroupRef.current.querySelectorAll("button");
                var maxWidth_1 = 0;
                buttons.forEach(function (button) {
                    var width = button.getBoundingClientRect().width;
                    if (width > maxWidth_1) {
                        maxWidth_1 = width;
                    }
                });
                buttonGroupRef.current.style.setProperty("--equisized-width", "".concat(maxWidth_1, "px"));
            }
            else {
                buttonGroupRef.current.style.setProperty("--equisized-width", "auto");
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [equisized, children, size, inline, iconPosition]);
    var _className = classNames("fr-btns-group", (_b = {},
        _b["fr-btns-group--".concat(size)] = size && size !== "md",
        _b["fr-btns-group--".concat(align)] = align && align !== "left",
        _b["fr-btns-group--icon-".concat(iconPosition)] = iconPosition,
        _b["fr-btns-group--inline"] = inline === true,
        _b["fr-btns-group--inline-".concat(inline)] = typeof inline === "string",
        _b["fr-btns-group--inline-reverse"] = reverse,
        _b["fr-btns-group--equisized"] = equisized,
        _b), className);
    if (otherProps && !otherProps.title && titleName) {
        otherProps.title = titleName;
    }
    var content = Children.toArray(children).map(function (child, index) { return React.createElement("li", { key: index }, child); });
    return (React.createElement("ul", __assign({ ref: buttonGroupRef || ref, style: style, className: _className }, otherProps), content));
});
export default ButtonGroup;
